function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as k } from "react/jsx-runtime";
import * as p from "react";
import v from "classnames";
import { sprinkles as N } from "./sprinkles.css-mistica.js";
import { getPrefixedDataAttributes as z } from "./utils/dom.js";
const A = /*#__PURE__*/ p.forwardRef((param, u)=>{
    let { className: f, children: i, width: l, padding: b = 0, paddingX: m = b, paddingY: c = b, paddingTop: e = c, paddingBottom: o = c, paddingLeft: r = m, paddingRight: t = m, role: x, dataAttributes: y, "aria-label": j } = param;
    const S = {
        paddingTop: e,
        paddingBottom: o,
        paddingLeft: r,
        paddingRight: t
    };
    let a = {}, s = "";
    try {
        s = N(S);
    } catch (e1) {
        a = {
            paddingTop: typeof e == "object" ? e.mobile : e,
            paddingBottom: typeof o == "object" ? o.mobile : o,
            paddingLeft: typeof r == "object" ? r.mobile : r,
            paddingRight: typeof t == "object" ? t.mobile : t
        };
    }
    return /* @__PURE__ */ k("div", _object_spread_props(_object_spread({}, z(y)), {
        role: x,
        "aria-label": j,
        ref: u,
        className: v(f, s),
        style: _object_spread({}, l !== void 0 ? {
            width: l,
            boxSizing: "border-box"
        } : {}, s ? {} : a),
        children: i
    }));
}), w = A;
export { w as default };
